import './App.css';
import WazoDashboard from './components/WazoDashboard';

function App() {
  return (
    <div className="App">
      <WazoDashboard />
    </div>
  );
}

export default App;
